import { FormattedMessage } from "react-intl";
import CurrencyNumber from "../../../cmp/CurrencyNumber";
import Button from "../../../cmp/form/Button";
import RenderInterval from "./RenderInterval";
import ShopifyBuyButton from "./ShopifyBuyButton";
import ShopifyTestForPurchase from "./ShopifyTestForPurchase";
import StyledButton from "../../../cmp/themed/StyledButton";
import {useSelector} from "react-redux";
import WoocommerceAddToCart from "./WoocommerceAddToCart";

export default function PlanCard({
  cost,
  plan_title,
  num_plans,
  plan_id,
  plan_type,
  perks,
  description,
  interval_count,
  interval_unit,
  has_trial,
  trial_label,
  trial_interval_count,
  trial_interval_unit,
  trial_cost,
  selling_plan_id,
  upsells,
  onChoose,
  loading,
  isChosen,
  currency,
  storefront_access_token,
  product,
}) {
  const integration = useSelector((state)=>state.settings.integration);
  return (
    <div className={"card flex-fill"}>
      <div className="flex-fill">
        <div className="p-3">
          <h5 className="card-title text-center">{plan_title}</h5>
          <div className={"text-center"}>
            {plan_type === "recurring" ? (
              <>
                {has_trial ? (
                  <div>
                      <span className="badge badge-info">{trial_label}</span>
                      <div className="fs-2">
                        <CurrencyNumber
                          currency={currency}
                          value={trial_cost}
                        />
                        <span className="text-muted" style={{ fontSize: "0.8rem" }}>&nbsp;now
                        </span>
                      </div>
                    after {trial_interval_count} {trial_interval_unit.toLowerCase()} <CurrencyNumber currency={currency} value={cost} />
                    <span className={"text-muted"} style={{ fontSize: "0.8rem" }}>
                      /
                      <RenderInterval
                        interval_count={interval_count}
                        interval_unit={interval_unit}
                      />
                    </span>
                  </div>
                ) : (
                  <div className={"fs-2"}>
                    <CurrencyNumber currency={currency} value={cost} />
                    <span className={"text-muted"} style={{ fontSize: "1rem" }}>
                      /
                      <RenderInterval
                        interval_count={interval_count}
                        interval_unit={interval_unit}
                      />
                    </span>
                  </div>
                )}
              </>
              ) :  <div className={"fs-2 mb-2"}>
              <CurrencyNumber currency={currency} value={cost} /></div>
            }
          </div>
          {plan_type === "one_time_purchase" && integration === "shopify" ? (
            <>
              <div className={"text-center"}>
                <ShopifyBuyButton
                  upsells={upsells}
                  selling_plan_id={selling_plan_id}
                  plan_id={plan_id}
                  product={product}
                  storefront_token={storefront_access_token}
                />
              </div>
              <div>
                <ShopifyTestForPurchase
                  plan_id={plan_id}
                  plan_title={plan_title}
                />
              </div>
            </>
          ) : null}
          {plan_type === "one_time_purchase" && integration === "woocommerce" ? (
              <>
                <div className={"text-center"}>
                  <WoocommerceAddToCart
                      upsells={upsells}
                      selling_plan_id={selling_plan_id}
                      plan_id={plan_id}
                      product={product}
                      storefront_token={storefront_access_token}
                  />
                </div>
                {/*<div>*/}
                {/*  <ShopifyTestForPurchase*/}
                {/*      plan_id={plan_id}*/}
                {/*      plan_title={plan_title}*/}
                {/*  />*/}
                {/*</div>*/}
              </>
          ) : null}
        </div>
        {perks && perks.split("\n").length > 0 && (
          <ul className={"list-group list-group-flush"}>
            {perks &&
              perks
                .split("\n")
                .filter((item) => item)
                .map((item) => (
                  <li key={item} className={"text-center list-group-item"}>
                    {item}
                  </li>
                ))}
          </ul>
        )}
        {description && (
          <div
            className="card-body"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>

      {num_plans > 1 && plan_type !== "one_time_purchase" ? (
        <div className="card-footer text-center">
          <StyledButton
            disabled={loading && !isChosen}
            loading={loading && isChosen}
            className={`btn btn-primary`}
            onClick={onChoose}
          >
            <FormattedMessage id={"Choose"} />
          </StyledButton>
        </div>
      ) : null}
    </div>
  );
}
